/**
 * @param floatYn -- floating-botn class
 * @param containerRole -- div data-role
 * @param strongWord -- strong tag word
 * @param h4Word  -- h4 tag word
 * @param landingUrl -- a tag url
 * @param listRole -- ul data-role
 * @param tlCode -- tlCode
 */

export const renderPc = ({
  floatYn,
  containerRole,
  strongWord,
  strongClass,
  h4Word,
  landingUrl,
  listRole,
  tlCode,
  dataSize,
  itemList,
  tlArea,
  key,
}) => {
  let btnShowHide = false;
  if (dataSize > 6 || (floatYn === 'floating-both' && dataSize > 3)) {
    btnShowHide = true;
  }

  let tooltipHtml = "";
  if (
    TMON.oApp.htStorage.htStaticData.htDealInfo.deliveryInfo
      .deliveryFeePolicy === "CONDITION" &&
    key === "combineDelivery"
  ) {
    tooltipHtml = `
      <div class="default_tip">
        <a href="javascript:return false;" class="btn_help_tip">묶음배송 상품 정보</a>
        <div class="pop_tooltip_sale">
            <div class="inner">
                <p class="txt">함께 사면 배송료가 무료인 다른 상품입니다.</p>
            </div>
        </div>
      </div>
  `;
  }

  return `
    <div class='ct_wrp another-deal-wrap ${floatYn}' 
        data-role='${containerRole}' 
        data-wrap="another-deal-wrap-has-paging">
      <h4 class="tit_align_top">
        ${h4Word[0]}
        <strong class='${strongClass}'>
        ${strongWord}
        </strong>
        ${h4Word[1]}
        ${tooltipHtml}
        ${
          landingUrl
            ? `<a href=${TMON.util.preventMixedContent(landingUrl)} class='btn_more_info'>더보기</a>`
            : ''
        }
      </h4>
    <ul class='deal-list' data-role=${listRole}>
    ${drawPcItem(itemList, tlArea, key)}
    </ul>
    ${btnShowHide ? renderControlButtons(tlCode) : ''}
    </div>`;
};

const drawPcItem = (itemList, tlArea, key) => {
  const sHtml = itemList
    .map((item, i) => {
      const isAd = !!item.admonClickUrl;
      const sUrl = TMON.util.preventMixedContent(
        key === "seenSeenDeal" && isAd ? getSmartAiUrl(item) : getUrl(item)
      );

      return `
      <li>
        ${tlArea
          ? `<a href="${sUrl}" data-ad="${isAd}" data-tlarea="${tlArea}" data-tlord="${i + 1}">`
          : `<a href="${sUrl}" data-ad="${isAd}">`
        }
          <figure>
            <img src="${TMON.util.preventMixedContent(item.imageInfo.mobile3ColImageUrl)}" 
              alt="${TMON.oApp.oUtil.removeStringElement(item.titleName, ['BR',])}" width="90" height="92">
              ${TMON.oApp.oTemplate.getMasking(item)}
          </figure>
          <div class="information-wrap">
            <strong class="deal_name">
              ${TMON.oApp.oUtil.removeStringElement(item.titleName, ['BR'])}
            </strong>
            <div class="purchase_info">
              ${TMON.oApp.oTemplate.getInterGratedDealsPriceType(item)}
            </div>
          </div>
          ${
            isAd
            ? `<span class="lyr_info">
                <button type="button" class="btn">AD</button>
                <span class="box">스마트 AI Plus 광고를 구매한 상품으로 고객 맞춤형 AI 추천 광고입니다.</span>
              </span>`
            : ""
          }
        </a>
      </li>`;
    })
    .join('');
  return sHtml;
};

export const renderMobileDeal = ({
  spanWord,
  spanClass,
  mobileH4Word,
  landingUrl,
  itemList,
  containerRole,
  dataSize,
  aTagDataRole,
  aSpanWord,
  tlArea,
  key
}) => {
  /**
   * Mobile Drawing
   * @param spanWord
   * @param spanClass
   * @param mobileH4Word
   * @param landingUrl
   * @param itemList
   * @param containerRole
   * @param dataSize
   * @param aTagDataRole -- aTagDataRole
   * @param aSpanWord -- atag span word
   */
  if (!dataSize || dataSize === 0) {
    return;
  }

  const isSeenSeenDeal = key === 'seenSeenDeal';

  const sHtml = `
      <div class="deallist_scroll_title_wrap">
          <h4 class="deallist_scroll_title">
            ${mobileH4Word[0]}
            ${!isSeenSeenDeal ? `<span class='${spanClass}'>${spanWord}</span> ${mobileH4Word[1]}` : ''}
          </h4>
      </div>
      <div class="deallist_scroll_inner">
        <ul>
          ${itemList
            .map((item, i) => {
              const isAd = !!item.admonClickUrl;
              const sUrl = TMON.util.preventMixedContent(
                isSeenSeenDeal && isAd ? getSmartAiUrl(item) : getUrl(item)
              );
              return `<li>
                ${tlArea
                  ? `<a href="${sUrl}" class="deallist_scroll_link" data-ad="${isAd}" data-tlarea="${tlArea}" data-tlord="${i + 1}">`
                  : `<a href="${sUrl}" class="deallist_scroll_link" data-ad="${isAd}">`
                }
                  <div class="deallist_scroll_item">  
                    <div class="thumb">
                      <img src=${TMON.util.preventMixedContent(item.imageInfo.mobile3ColImageUrl)} 
                        alt=${TMON.oApp.oUtil.removeStringElement(item.titleName, ['BR'])} />
                      ${TMON.oApp.oTemplate.getMasking(item)}
                    </div>
                    <div class="info">
                      <strong class="title">
                        ${TMON.oApp.oUtil.removeStringElement(item.titleName, ['BR'])}
                      </strong>
                      <div class="price">
                        ${TMON.oApp.oTemplate.getInterGratedDealsPriceType(item)}
                      </div>
                    </div> 
                  </div>
                </a>
                ${isAd ? 
                  `<div class="ad_area">
                    <button class="ad_info" type="button">AD <i></i></button>
                    <p class="ad_desc">
                      스마트 AI Plus 광고를 구매한 상품으로 고객 맞춤형 AI 추천 광고입니다.
                      <button type="button"><span class="blind">닫기</span></button>
                    </p>
                  </div>` : ''}
              </li>`;
            })
            .join('')}
        </ul>
      </div>
      ${
        isValidGoCombinedDeliveryButton() && aTagDataRole
          ? `<a href="${landingUrl}" class="deallist_scroll_button" data-role=${aTagDataRole}>
            <span class="text">${aSpanWord} 더보기</span>
            <span class="ico_svg">
              <svg xmlns="http://www.w3.org/2000/svg" width="5" height="9" viewBox="0 0 5 9">
                <path fill="#959DA6" fill-rule="nonzero" d="M4.22 4.404L0 8.624.395 9 5 4.395.39 0 .005.385z"/>
              </svg>
            </span>
          </a>`
          : ''
      }
  `;
  $(`[data-role=${containerRole}]`)
    .html(sHtml)
    .show();
};

/**
 * isValidGoCombinedDeliveryButton
 * 묶음상품 더보기(전체보기) 버튼 사용 가능한 앱 환경인지 검증하여 리턴한다.
 */
const isValidGoCombinedDeliveryButton = () => {
  /* eslint-disable no-underscore-dangle */
  if (TMON.view_mode === 'app' && !TMON.app._isValidAppVersion('4.5.8')) {
    return false;
  }
  return true;
};

/**
 * launchInfo.type
 *  NORMAL: 자바전환 안된 딜,
 *  WEB_DETAIL: 자바전환 딜
 */
const getUrl = item => {
  return item.launchInfo.type === 'NORMAL'
    ? TMON.util.aup(
        `${TMON.htLocal.htURL.www_m_dealDetail}/${item.dealNo}`,
        TMON.sAppQuery
      )
    : TMON.util.aup(
        `${TMON.htLocal.htURL.www_m_deals}${item.dealNo}`,
        TMON.sAppQuery
      );
};

const getSmartAiUrl = item => {
  return TMON.util.aup(
    `${item.admonClickUrl}&fwUrl=${encodeURIComponent(
      TMON.util.aup(
        `${TMON.htLocal.htURL.www_m_deals}${item.dealNo}`,
        TMON.sAppQuery
      )
    )}`,
    TMON.sAppQuery
  );
}

/* 좌우 버튼 만들기 */
const renderControlButtons = tlCode => {
  return `
            <div class="control">
                <div class="control_count" data-role="intergratedPaginateNumber"></div>
                <button type="button" class="control_button_left" aria-label="이전" data-role="intergratedPaginateButton" data-type="prev" data-tlarea=${tlCode} data-tlord="1">
                    <span class="control_button_ico">
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12">
                            <path fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" d="M12 10L18 16 12 22" transform="matrix(-1 0 0 1 19 -10)"></path>
                        </svg>
                    </span>
                </button>
                <button type="button" class="control_button_right" aria-label="다음" data-role="intergratedPaginateButton" data-type="next" data-tlarea=${tlCode} data-tlord="2">
                    <span class="control_button_ico">
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12">
                            <path fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" d="M12 10L18 16 12 22" transform="matrix(-1 0 0 1 19 -10)"></path>
                        </svg>
                    </span>
                </button>
            </div>
        `;
};
